import moment from 'moment';
import 'moment/locale/de-at';
import 'moment/locale/fr';
import 'moment/locale/ru';
import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/ja';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';
import 'moment/locale/ko';
import 'moment/locale/pt-br';
import 'moment/locale/th';
import 'moment/locale/en-gb'; // strange...locale seems to default to last imported locale if
// specified locale does not match...thus putting en-gb last here...

// TODO NG RP 2017-06-26: Fix issue with moment.
// There is currently an issue whereby if the provided date- time is invalid in the client's
// timezone moment will "make the time valid" by adding an hour which can make the start or end time
// wrong.

const japaneseOrChineseLocales = ['ja', 'zh-cn', 'zh-hk'];
const isJapaneseOrChineseLocale = () => japaneseOrChineseLocales.includes(moment.locale());
const isAmericanLocale = () => moment.locale().toLocaleLowerCase() === 'en';
const isRussianLocale = () => moment.locale().toLocaleLowerCase() === 'ru';

function capitalize(input) {
  return input.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

const formatAmericanDate = (dateString) => capitalize(moment(dateString).format('MMM Do'));

export function formatTime(dateString) {
  return moment(dateString).format('HH:mm');
}

export function formatMediumDate(dateString) {
  if (isJapaneseOrChineseLocale()) {
    return moment(dateString).format('MMM Do');
  }
  if (isAmericanLocale()) {
    return formatAmericanDate(dateString);
  }
  if (isRussianLocale()) {
    moment.locale('ru');
    const day = moment(dateString).format('D');
    const month = moment(dateString).format('MMM');
    const formattedDate = `${day} ${month.substr(0, 3)}`;
    return formattedDate;
  }

  return capitalize(moment(dateString).format('Do MMM'));
}

export function formatDayName(dateString) {
  return moment(dateString).format('dddd');
}

export function formatLongDate(dateString) {
  return moment(dateString).format('YYYY-MM-DD');
}

export function toMoment(dateString) {
  return moment(dateString);
}

export function setMomentLocale(locale) {
  moment.locale(locale);
}

export function formatDayNameAndDate(date) {
  return isJapaneseOrChineseLocale()
    ? `${formatMediumDate(date)} ${formatDayName(date)}`
    : `${formatDayName(date)}, ${formatMediumDate(date)}`;
}

export function formatDateForLocale(dateString, format, locale) {
  return moment(dateString).locale(locale || 'en-GB').format(format);
}

export function formatDayNameAndDateForLocale(dateString, locale) {
  const localisedMoment = moment(dateString).locale(locale || 'en-GB');
  const format = 'ddd DD MMMM';
  return localisedMoment ? localisedMoment.format(format) : moment(dateString).format(format);
}
